import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { threshold: Number };

  connect() {
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);

    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize, { passive: true });

    // Get navigation height and position dynamically
    this.setNavigationOffset();

    // Set initial state
    this.handleScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    // Reposition on window resize
    this.setContentContainerOffset();
  }

  setNavigationOffset() {
    const navigation = document.getElementById("navigation");
    if (navigation) {
      const navHeight = navigation.offsetHeight;
      // Add small padding below navigation
      this.element.style.top = `${navHeight + 8}px`;
    }

    // Position within content container boundaries
    this.setContentContainerOffset();
  }

  setContentContainerOffset() {
    // Find the main content container (max-w-7xl mx-auto)
    const contentContainer = document.querySelector(".max-w-7xl.mx-auto");
    if (contentContainer) {
      const containerRect = contentContainer.getBoundingClientRect();
      const containerLeft = containerRect.left;
      // Position button 16px from the left edge of the content container
      this.element.style.left = `${containerLeft + 16}px`;
    }
  }

  handleScroll() {
    const scrollY = window.scrollY;
    const threshold = this.thresholdValue || 300;

    if (scrollY > threshold) {
      // Show sticky button
      this.element.style.transform = "translateY(0)";
      this.element.style.opacity = "1";
    } else {
      // Hide sticky button
      this.element.style.transform = "translateY(-100%)";
      this.element.style.opacity = "0";
    }
  }
}
